<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div class="modal-card view-contact-modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Proposals</p>
            <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                <o-icon pack="fa" icon="gear" size="is-small"/>
            </a>
        </header>
        <section class="modal-card-body">
            <o-table
                class="is-responsive is-responsive-xs-desktop"

                v-if="isTableVisible"
                :data="paginatedData"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort-direction="table.defaultSortDirection"
                :default-sort="table.defaultSort"

                v-model:selected="selected"
                :checked-rows="checkedRows"
                @update:checkedRows="$event => checkedRows = $event"

                :loading="loading"
                :total="total"
                backend-sorting
                backend-pagination
                @page-change="onPageChange"
                @sort="onSort"
            >
                <template>
                    <template>
                        <div v-for="col in tableColumns">
                          <o-table-column
                              :field="col.field"
                              :label="col.field === 'actions' ? '' : col.label"
                              :key="col.field"
                              :sortable="col.sortable"
                              #default="{ row }"
                          >
                            <proposal-column v-if="col.field !== 'actions'" :field="col.field" :item="row" />

                            <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                              <template v-slot:trigger>
<button class="button" >
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                              </button>
</template>

                              <o-dropdown-item has-link><router-link :to="{ name: 'proposals.show', params: { slug: row.id } }">View</router-link></o-dropdown-item>
                              <o-dropdown-item has-link v-if="row.project_id"><router-link :to="`/projects/${row.project_id}`">View Project</router-link></o-dropdown-item>
                              <o-dropdown-item has-link><a :href="`/proposals/${row.id}/pdf`" @click.prevent.stop="openPreviewModal(row)">Preview PDF</a></o-dropdown-item>
                              <o-dropdown-item has-link><a @click="openMessageModal({entity: row, entity_type: 'proposal', context: 'proposal-request-signature-message'})">Send to Customer</a></o-dropdown-item>
                              <o-dropdown-item has-link><a @click="openReminderModal(row.id)">Set Reminder</a></o-dropdown-item>
                              <o-dropdown-item has-link><a @click.prevent="openMessageModal({entity: row, entity_type: 'proposal', context: 'proposal-reminder-message'})">Send Reminder to Customer</a></o-dropdown-item>
                              <o-dropdown-item has-link v-if="!row.project_id"><a @click.stop.prevent="convertToProject(row)">Convert To Project</a></o-dropdown-item>
                            </o-dropdown>
                          </o-table-column>
                        </div>

                    </template>
                </template>

                <template v-slot:empty>
<div  class="has-text-centered">
                    This table is empty!
                </div>
</template>
            </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="proposalId" reference-type="proposal"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
import ProposalColumn from './../../components/table-columns/Proposal';
import Table from './../../mixins/Table';
import PreviewModal from './Preview';

    export default {
        mixins: [Table],

        props: ['companyId', 'status', 'leadSource', 'year', 'month'],

        components: {
            ProposalColumn,
            PreviewModal
        },

        data () {
            return {
                isReminderModalActive: false,
                tableName: 'proposals-index',
                isPreviewModalActive: false,
                currentPreviewFile: null,
                currentProposal: null,
                proposalId: null,
                requestParams: {
                    lead_source_id: this.leadSource,
                    company_id: this.companyId,
                    status: this.status,
                    year: this.year,
                    month: this.month,
                }
            }
        },

        computed: {
            ...mapGetters({
                itemsByIds: 'proposalsByIds'
            })
        },

        mounted () {
            this.fetchPaginatedData(true, this.requestParams)
        },

        methods: {
            ...mapActions({
                removeItem: 'removeProposal',
                fetchData: 'fetchProposals'
            }),

            ...mapActions([
                'openMessageModal',
                'convertProposal',
            ]),

            convertToProject (proposal) {
                this.convertProposal(proposal)
                    .then(res => {
                        this.successMessage('Proposal was successfully converted to a project')
                        return res
                    })
            },

            openPreviewModal(proposal) {
                this.proposalId = proposal.id
                this.isPreviewModalActive = true

                this.currentPreviewFile = {
                    name: `Proposal #${proposal.number}`,
                    path: `${location.protocol}//${window.location.hostname}/proposals/${proposal.id}/pdf`,
                    mime: 'application/pdf',
                    generatedOnTheFly: true
                }
            },

            openReminderModal (proposalId) {
                this.isReminderModalActive = true
                this.proposalId = proposalId
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 100%;
    }
</style>
